import NewsFeed from './views/NewsFeed'
import UploadImagesFeed from './views/UploadImagesFeed'
import ExecutionFocusList from './views/ExecutionFocusList'
import CreateExecutionFocus from './views/CreateExecutionFocus'
import ExecutionFocusDashboard from './views/ExecutionFocusDashboard'

export default [
  {
    path: 'store_publication_content',
    name: 'StorePublicationContent',
    component: NewsFeed,
    props: true
  },
  {
    path: 'upload_images_feed',
    name: 'UploadImagesFeed',
    component: UploadImagesFeed,
    props: true
  },
  {
    path: 'execution_focus',
    name: 'ExecutionFocusList',
    component: ExecutionFocusList,
    props: true
  },
  {
    path: 'execution_focus_create',
    name: 'CreateExecutionFocus',
    component: CreateExecutionFocus,
    props: true
  },
  {
    path: 'execution_focus/:id/results',
    name: 'ExecutionFocusDashboard',
    component: ExecutionFocusDashboard,
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/news_feed/Routes.js